import { render, staticRenderFns } from "./commission_indro.vue?vue&type=template&id=4090f224&"
import script from "./commission_indro.vue?vue&type=script&lang=js&"
export * from "./commission_indro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports